import { ChangeDetectionStrategy, Component, ElementRef, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CopyButtonComponent } from 'src/app/components/copy-button/copy-button.component';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';
import { SensitiveMessageContentComponent } from '../sensitive-content/sensitive-message-content.component';
import { CitedSource, CitationResourceType } from '../../../enterprise-ai-agent-step/ai-agent-citation.component';
import { ActivityMessage } from '../activity-message.types';
import { ActivitySourcesComponent } from '../sources/activity-sources.component';
import { Severities, SeveritiesCellComponent } from 'src/app/components/severities-cell/severities-cell.component';

@Component({
  selector: 'app-activity-message',
  standalone: true,
  templateUrl: './activity-message.component.html',
  styleUrls: ['./activity-message.component.scss'],
  imports: [
    CommonModule,
    SensitiveMessageContentComponent,
    LabelsProviderPipe,
    CopyButtonComponent,
    MatTooltipModule,
    ActivitySourcesComponent,
    SeveritiesCellComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityMessageComponent {
  public messages = input.required<ActivityMessage[]>();
  public id = input.required<string>();
  public citedSources = input<CitedSource[]>([]);
  public sources = input<CitedSource[]>([]);
  public timestamp = input.required<Date>();
  public relatedFindings = input<Severities>();

  public findingsForActivityClicked = output<string>();

  constructor(private readonly _elementRef: ElementRef) {}

  scrollToMessage(): void {
    this._elementRef.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  protected readonly CitationResourceType = CitationResourceType;

  public isDictSeverityNotEmpty(dictSeverity: Record<string, number> | undefined): boolean {
    return !!(dictSeverity && Object.keys(dictSeverity).length > 0);
  }
}
